<template>
  <div>
    <a-spin :spinning="colorLoading">
      <div class="titleDiv">
        <div></div>
        <p>请选择球衣颜色</p>
      </div>
      <div class="colorDiv">
        <div class="subColor">
          <p>主场</p>
          <div>
            <input class="color" data-jscolor="{}" :value="homeColor" @change="colorChange($event, 'homeColor')" />
            <img :src="shirt" :style="{backgroundColor: homeColor}"/>
          </div>
        </div>
        <div class="subColor">
          <p>客场</p>
          <div>
            <input class="color" data-jscolor="{}" :value="visitColor" @change="colorChange($event, 'visitColor')" />
            <img :src="shirt" :style="{backgroundColor: visitColor}"/>
          </div>
        </div>
        <div class="subColor" v-if="programId === 4">
          <p>守门员主场</p>
          <div>
            <input class="color" data-jscolor="{}" :value="homeKeeperColor" @change="colorChange($event, 'homeKeeperColor')" />
            <img :src="shirt" :style="{backgroundColor: homeKeeperColor}"/>
          </div>
        </div>
        <div class="subColor" v-if="programId === 4">
          <p>守门员客场</p>
          <div>
            <input class="color" data-jscolor="{}" :value="visitKeeperColor" @change="colorChange($event, 'visitKeeperColor')" />
            <img :src="shirt" :style="{backgroundColor: visitKeeperColor}"/>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
import jscolor from '@comm/components/join/colorPicker/jscolor'
export default {
  props: {
    teamId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      colorLoading: false,
      programId: this.$route.query.programId,
      shirt: require('@comm/assets/join/shirt.png'),
      homeColor: '#FE4848',
      visitColor: '#FAFAFA',
      homeKeeperColor: '#713737',
      visitKeeperColor: '#efd0d0'
    }
  },
  mounted () {
    jscolor.jscolor.install()
  },
  methods: {
    colorChange (e, target) {
      let color = e.target.value
      if (target === 'homeColor') {
        this.homeColor = color
      } else if (target === 'visitColor') {
        this.visitColor = color
      } else if (target === 'homeKeeperColor') {
        this.homeKeeperColor = color
      } else {
        this.visitKeeperColor = color
      }
    },
    resetColor () {
      this.homeColor = '#FE4848'
      this.visitColor = '#FAFAFA'
      this.homeKeeperColor = '#713737'
      this.visitKeeperColor = '#efd0d0'
    },
    queryShirtColor () {
      this.colorLoading = true
      let agencyId = this.$route.query.agencyId
      this.$api.join.findJerseyColor(agencyId, this.teamId).then(res => {
        if (res.status === 0) {
          let data = res.data
          this.homeColor = data.homeCourtColor || '#FE4848'
          this.visitColor = data.awayCourtColor || '#FAFAFA'
          this.homeKeeperColor = data.homeGoalkeeperCourtColor || '#713737'
          this.visitKeeperColor = data.visitingGoalkeeperCourtColor || '#efd0d0'
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('获取球衣颜色失败')
      }).finally(_ => {
        this.colorLoading = false
      })
    },
    getShirtColor () {
      return {
        homeColor: this.homeColor,
        visitColor: this.visitColor,
        homeKeeperColor: this.homeKeeperColor,
        visitKeeperColor: this.visitKeeperColor
      }
    }
  },
  watch: {
    teamId (newValue, oldValue) {
      if (newValue != null) {
        this.queryShirtColor()
      } else {
        this.homeColor = '#FE4848'
        this.visitColor = '#FAFAFA'
        this.homeKeeperColor = '#713737'
        this.visitKeeperColor = '#efd0d0'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .titleDiv {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
    div {
      height: 25px;
      width: 5px;
      background-color: #b80000;
    }
    p {
      font-size: 19px;
      font-weight: bold;
      margin-bottom: 0px;
      margin-left: 10px;
    }
  }
  .colorDiv {
    min-height: 155px;
    overflow: hidden;
    border: 1px solid #ebedf0;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
    .subColor {
      border: 1px solid #ebedf0;
      background: #fff;
      height: 130px;
      width: 260px;
      padding: 10px;
      display: flex;
      margin-right: 20px;
      p {
        width: 85px;
        font-size: 15px;
        font-weight: bold;
      }
      div {
        position: relative;
        width: 162px;
        z-index: 999;
        input {
          position: absolute;
          border: none;
          outline: none;
          opacity: 0;
          z-index: 20;
          cursor: pointer;
          width: 162px;
          height: 100px;
        }
        img {
          position: absolute;
          background-color: #e2e0e0;
          height: 100px;
          z-index: 10;
          margin-left: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/bigBall/ShirtColor.vue